<template>
  <div class="not-found">
    <h1>404 页面未找到</h1>
    <p>抱歉，您所访问的页面可能在另一个地方。</p>
    <router-link to="/">返回首页</router-link>
  </div>
</template>

<script>
export default {
  // 组件逻辑
}
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 100px;
}

h1 {
  font-size: 48px;
  color: #333;
}

p {
  font-size: 18px;
  color: #666;
}

router-link {
  display: block;
  margin-top: 100px;
  font-size: 16px;
  color: #007BFF;
}
</style>
